import React from "react";
import { Link } from "react-router-dom";
import style from "./PageNotFound.module.css";

function PageNotFound() {
  return (
    <>
      <div className={style.divMessage + " container"}>
        <h1>Error 404</h1>
        <h2 className="text-muted">Lo sentimos! Pagina no encontrada</h2>
        <h3 className="text-muted">
          Puedes ir al Inicio haciendo{" "}
          <Link to="/" className={style.btnHome + " btn"}>
            {" "}
            click aquí
          </Link>
        </h3>
      </div>
    </>
  );
}

export default PageNotFound;
